import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { axios } from '../../../services/axios';

export default class ListMenus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      menus: [],
    };
  }

  componentDidMount() {
    document.title = 'Menus';
    this.getData();
  }

  getData() {
    axios
      .get('/menus')
      .then((response) => {
        this.setState({
          menus: response.data,
          loading: false,
        });
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  render() {
    if (this.state.loading) {
      return <div className={'loader'} />;
    } else {
      return (
        <div>
          <div className={'m-portlet m-portlet--full-height  m-portlet--unair'}>
            <div className={'m-portlet__head'} style={{ height: 'auto' }}>
              <div className={'row'} />
              <div className={'m-portlet__head-tools'}>
                {JSON.parse(localStorage.getItem('user')) &&
                  JSON.parse(localStorage.getItem('user')).user_permissions.includes(
                    'CREATE_MENUS',
                  ) && (
                    <div>
                      <Link
                        to={'menus/create'}
                        color={'success'}
                        className={
                          'm-portlet__nav-link btn btn-lg btn-secondary  m-btn m-btn--icon m-btn--icon-only m-btn--pill'
                        }>
                        <i className={'la la-plus-circle m--font-brand'} />
                      </Link>
                    </div>
                  )}
              </div>
            </div>
            <div className={'m-portlet__body'}>
              <div className={'tab-content'}>
                {/* begin::Widget */}
                <div className={'m-widget11'}>
                  <div className={'table-responsive'}>
                    {/* begin::Table */}
                    <table className={'table table-striped m-table'}>
                      {/* begin::Thead */}
                      <thead>
                        <tr>
                          <td>{'#'}</td>
                          <td>{'Name'}</td>
                          <td>{'City'}</td>
                          <td>{'Zone'}</td>
                          <td>{'Actions'}</td>
                        </tr>
                      </thead>
                      {/* end::Thead */}

                      {/* begin::Tbody */}
                      <tbody>
                        {this.state.menus.map(function(menu, index) {
                          return (
                            <tr id={`menu-${menu.id}`} key={index}>
                              <td>{menu.id}</td>
                              <td>{menu.name}</td>
                              <td>
                                {menu.zones?.length > 0 && menu.zones[0]?.city
                                  ? menu.zones[0]?.city.en_name
                                  : ''}
                              </td>
                              <td>{menu.zones && menu.zones?.map((zone) => zone.name)?.join(', ')}</td>
                              <td>
                                <span>
                                  <Link to={`menus/${menu.id}`}>
                                    <button
                                      id={'menu-view-button'}
                                      className={
                                        'btn btn-lg btn-secondary m-btn m-btn--icon m-btn--icon-only m-btn--pill btn-success'
                                      }>
                                      <i className={'la la-eye m--font-brand'} />
                                    </button>
                                  </Link>
                                </span>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                      {/* end::Tbody */}
                    </table>
                    {/* end::Table */}
                  </div>

                  <div className={'m-widget11__action m--align-right'} />
                </div>
                {/* end::Widget 11 */}
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}
